import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 引入微信插件
import wechatPlugin from '@/plugins/wechat'
import { isWechatBrowser } from '@/plugins/wechat'
import { fullInitShare } from '@/utils/shareInitializer'
import { initUrlChangeListener } from '@/utils/wechatShareEnhanced'
import { 
  Button, 
  Tabbar, 
  TabbarItem,
  NavBar,
  Grid,
  GridItem,
  Card,
  Image as VanImage,
  ImagePreview,
  Icon,
  Tag,
  Cell,
  CellGroup,
  Form,
  Field,
  Switch,
  Popup,
  Area,
  Toast,
  Loading,
  List,
  PullRefresh,
  Empty,
  Picker,
  Collapse,
  CollapseItem,
  NoticeBar,
  Dialog,
  PasswordInput,
  NumberKeyboard,
  DatePicker,
  Stepper,
  Uploader,
  Calendar,
  Tab,
  Tabs
} from 'vant'
import 'vant/lib/index.css'
import './assets/css/dialog.css'
import './assets/css/vant-override.css'
import './assets/css/button-styles.css'

const app = createApp(App)

// 全局错误处理
app.config.errorHandler = (error, instance, info) => {
  console.error('Global error handler:', error, info)
  // 可以在这里添加错误上报逻辑
}

// 处理未捕获的Promise错误
window.addEventListener('unhandledrejection', event => {
  console.error('Unhandled promise rejection:', event.reason)
  event.preventDefault()
})

// 注册 Vant 组件
;[
  Button,
  Tabbar,
  TabbarItem,
  NavBar,
  Grid,
  GridItem,
  Card,
  VanImage,
  ImagePreview,
  Icon,
  Tag,
  Cell,
  CellGroup,
  Form,
  Field,
  Switch,
  Popup,
  Area,
  Toast,
  Loading,
  List,
  PullRefresh,
  Empty,
  Picker,
  Collapse,
  CollapseItem,
  NoticeBar,
  Dialog,
  PasswordInput,
  NumberKeyboard
  , DatePicker
  , Stepper
  , Uploader
  , Calendar
  , Tab
  , Tabs
].forEach(component => {
  app.use(component)
})

app.use(store)
app.use(router)
app.use(wechatPlugin)

// 在应用挂载前设置meta标签
const setInitialMetaTags = () => {
  const metaTags = [
    { name: 'wechat:title', content: '蒙古丽人商城' },
    { name: 'wechat:description', content: '专注于蒙古服饰设计、开发、推广,定制热线:133 4714 1793' },
    { name: 'wechat:image', content: 'https://mall.sainbainu.com/static/images/sharelogo.png' },
    { property: 'og:title', content: '蒙古丽人商城' },
    { property: 'og:description', content: '专注于蒙古服饰设计、开发、推广,定制热线:133 4714 1793' },
    { property: 'og:image', content: 'https://mall.sainbainu.com/static/images/sharelogo.png' },
    { property: 'og:url', content: window.location.href }
  ]
  
  metaTags.forEach(tag => {
    let meta = document.querySelector(`meta[${tag.property ? 'property' : 'name'}="${tag.property || tag.name}"]`)
    if (!meta) {
      meta = document.createElement('meta')
      if (tag.property) {
        meta.setAttribute('property', tag.property)
      } else {
        meta.setAttribute('name', tag.name)
      }
      document.head.appendChild(meta)
    }
    meta.setAttribute('content', tag.content)
  })
  
  // 添加强制刷新meta的iframe技巧
  const iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  iframe.src = 'about:blank'
  document.body.appendChild(iframe)
  setTimeout(() => {
    document.body.removeChild(iframe)
  }, 100)
}

// 设置初始meta标签
setInitialMetaTags()

// 微信专用meta标签刷新技巧
const refreshWechatMeta = () => {
  // 1. 添加临时iframe强制刷新
  const iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  iframe.src = 'about:blank'
  document.body.appendChild(iframe)
  setTimeout(() => {
    document.body.removeChild(iframe)
  }, 100)
  
  // 2. 修改title强制刷新
  const originalTitle = document.title
  document.title = originalTitle + ' '
  setTimeout(() => {
    document.title = originalTitle
  }, 50)
  
  // 3. 添加临时meta标签
  const tempMeta = document.createElement('meta')
  tempMeta.name = 'temp-refresh-meta'
  tempMeta.content = Date.now()
  document.head.appendChild(tempMeta)
  setTimeout(() => {
    document.head.removeChild(tempMeta)
  }, 100)
}

// 初始化用户状态
store.dispatch('initUser')

// 检查是否在微信环境中
const wechatEnv = isWechatBrowser()
console.log('微信环境信息:', wechatEnv ? '是微信浏览器' : '非微信浏览器')

// 如果是微信环境，立即刷新meta标签
if (wechatEnv) {
  refreshWechatMeta()
}

// 防止重复初始化
let shareInitialized = false

// 在微信环境中初始化分享
if (wechatEnv && !shareInitialized) {
  shareInitialized = true
  console.log('Main.js: 开始初始化微信分享')
  
  // 初始化URL变化监听器，解决路由守卫添加tm参数导致的签名失效问题
  initUrlChangeListener()
  
  // 增加延迟，确保微信JS-SDK完全准备好
  setTimeout(() => {
    // 检查微信JS-SDK是否已准备好
    if (typeof wx !== 'undefined') {
      fullInitShare({
        title: '蒙古丽人商城',
        desc: '专注于蒙古服饰设计、开发、推广。定制热线:133 4714 1793',
        link: window.location.href,
        imgUrl: 'https://mall.sainbainu.com/static/images/sharelogo.png'
      }).then(() => {
        console.log('Main.js: 微信分享初始化完成')
      }).catch(error => {
        console.error('Main.js: 微信分享初始化失败:', error)
        // 如果初始化失败，重置标志以允许重试
        shareInitialized = false
      })
    } else {
      console.log('Main.js: 微信JS-SDK未准备好，稍后重试')
      shareInitialized = false
      // 如果微信JS-SDK未准备好，再延迟2秒重试
      setTimeout(() => {
        if (wechatEnv && !shareInitialized && typeof wx !== 'undefined') {
          shareInitialized = true
          fullInitShare({
            title: '蒙古丽人商城',
            desc: '专注于蒙古服饰设计、开发、推广。定制热线:133 4714 1793',
            link: window.location.href,
            imgUrl: 'https://mall.sainbainu.com/static/images/sharelogo.png'
          }).then(() => {
            console.log('Main.js: 微信分享初始化完成（重试）')
          }).catch(error => {
            console.error('Main.js: 微信分享初始化失败（重试）:', error)
          })
        }
      }, 2000)
    }
  }, 2000) // 增加延迟到2秒
}

app.mount('#app')
